module.exports = __webpack_public_path__ + "static/media/02-_DSC9682.fa8b8eff.jpg";